<template>
  <div>
    <Modal
        v-model="status"
        :mask-closable="false"
        :closable="false"
        :footer-hide="true"
    >
      <div class="top-line"></div>
      <div class="login-code-dialog">
        <div class="title">请使用登录码登录</div>
        <Form class="form-box" ref="loginFromRef" :model="loginFrom" :rules="loginFromRules" inline>
          <Form-item>
            <Input type="text" v-model="loginFrom.code" placeholder="请输入登录码">
              <i class="iconfont iconxiaoxi1" slot="prepend"></i>
            </Input>
          </Form-item>
          <Form-item>
            <div class="submitBtn" @click="handleSubmit()">登录</div>
          </Form-item>
        </Form>
      </div>

    </Modal>
  </div>

</template>

<script>
import {codeLogin} from "../api/Interface";
export default {
  name: "LoginCodeDialog",
  props:{
    status:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      loginFrom: {
        code: '',
      },
      loginFromRules: {
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ]
      }
    }
  },
  mounted(){

  },
  methods:{
    handleSubmit(){
      let params = {
        authcode:this.loginFrom.code,
        form_id:this.$route.query.id
      }
      codeLogin(params).then(res=>{
        if(res.state){
          this.$store.commit('saveLoginCode', this.loginFrom.code);
          this.$emit('callback');
        }else{
          this.$Message.error(res.error)
        }
      }).catch(err=>{
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .ivu-modal-content{
    background-color:rgba(255,255,255,0);
  }
  .top-line{
    height: 20px;
    background: #1a4bff;
    border: 4px solid #256eff;
    border-radius: 11px;
    box-shadow: 0 3px 6px 0 rgba(0, 53, 157, 0.62);
  }
  .login-code-dialog{
    height: 290px;
    background: url("../assets/images/duan0.png") no-repeat;
    padding: 20px 30px 0 30px;
    background-size: 100% 100%;
    margin-top: -23px;
    .title {
      font-size: 20px;
      color: #303133;
      text-align: center;
      font-weight: bold;
      height: 68px;
      line-height: 68px;
    }
    .form-box {
      height: calc(100% - 68px);
      padding-top: 20px;

      .ivu-form-item-error {
        /deep/ .ivu-input {

          &:focus {
            box-shadow: none;
            border-color: #ed4014 !important;
          }
        }
      }

      .btn {
        display: flex;
        color: #3559E0;
        align-items: center;
        font-size: 12px;
        border-left: 1px solid #D2D6EB;
        padding-left: 10px;

        .iconfont {
          font-size: 18px !important;
          margin-right: 5px;
        }
      }


      .ivu-form-item {
        width: 100%;
        margin-bottom: 35px;

        .ivu-input-group {
          height: 45px;

          /deep/ .ivu-input-group-prepend {
            background-color: transparent;

          }

          /deep/ .ivu-input {
            height: 45px;
            border-left: none !important;
            outline: none !important;
            -webkit-appearance: none; /*去除系统默认的样式*/
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/

            &:focus {
              box-shadow: none;
              border-color: #dcdee2;
            }
          }

          .iconfont {
            font-size: 22px;
          }

          /deep/ .ivu-input-group-append {
            background-color: transparent;
            border-left: none !important;
          }
        }

        .yzm {
          /deep/ .ivu-input {
            border-right: none !important;
          }
        }
      }
    }
    .submitBtn {
      width: 170px;
      height: 62px;
      display: block;
      border-radius: 18px;
      background: url("../assets/images/btn_y.png") no-repeat;
      font-size: 20px;
      line-height: 62px;
      color: #fff;
      background-size: cover;
      text-align: center;
      margin:0 auto;
    }
  }
</style>